// @flow

import * as React from 'react';
import Code from 'app/components/docs/shared/code';
import CodeBlock from 'app/components/docs/shared/code-block';
import Link from 'app/components/docs/shared/link';

type Props = {
  token?: string,
  className?: string,
  style?: Object
};

WindowsQuickStart.title = 'Windows';

function WindowsQuickStart(props: Props) {
  const { className, style } = props;

  return (
    <div className={className} style={style}>
      <ol>
        <li>
          Download the latest Windows beta from <Link href="https://github.com/buildkite/agent/releases">Buildkite Agent releases on GitHub</Link>
        </li>
        <li>
          Extract the files to a directory of your choice
        </li>
        <li>
          Edit <Code>buildkite-agent.cfg</Code> and add your token
        </li>
        <li>
          Run <Code>buildkite-agent start</Code> from a command prompt
        </li>
      </ol>

      <p className="rounded bg-silver p2">See the <Link href="/docs/agent/windows">Windows agent docs</Link> for more details.</p>

      <p>When asked, enter your agent token:</p>
      <CodeBlock language="markdown">
        { props.token || 'INSERT-YOUR-AGENT-TOKEN-HERE' }<br />
      </CodeBlock>
    </div>
  );
}

export default WindowsQuickStart;
